export default __webpack_public_path__ + "static/media/fad-vroundswitch-on.f512e027.svg";